import React from 'react';

import { Link } from "react-router-dom";

import ExternalLink from './ExternalLink';

import { PROJECT_ROOT } from '../constants';

interface ILinkWrapper {
  link?: string | false,
  external?: boolean,
  className?: string,
  hoverUnderline?: boolean,
  children: React.ReactNode,
  actionNameGA?: string,
  onClick?: () => void,
  onMouseEnter?: () => void,
  style?: any,
  target?: string,
}

// we use this component to dynamically handle internal links and external links

const LinkWrapper = (props: ILinkWrapper) => {
  const {
    link,
    external = false,
    className,
    children,
    hoverUnderline = false,
    actionNameGA,
    onMouseEnter,
    onClick,
    style,
    target = "_blank",
  } = props;

  if(external && link) {
    return (
      <ExternalLink target={target} onMouseEnter={() => onMouseEnter && onMouseEnter()} style={style ? style : {}} actionNameGA={actionNameGA} hoverUnderline={hoverUnderline} className={className} href={link}>
        {children}
      </ExternalLink>
    )
  }
  if(!external && link) {
    return (
      <Link
        style={style ? style : {}}
        onMouseEnter={() => onMouseEnter && onMouseEnter()}
        onClick={() => onClick && onClick()}
        className={[className, 'no-decorate', 'inherit-color', hoverUnderline ? "hover-underline" : ''].join(" ")}
        to={`${PROJECT_ROOT}${link}`}
      >
        {children}
      </Link>
    )
  }
  return (
    <>
      {children}
    </>
  );
}

export default LinkWrapper;